/**
 * Keeps a cloud palette identifier lossless while selecting a safe palette this
 * web build can actually render. This lets a newer Android earned theme survive
 * an older web client without letting an unknown value leak into CSS.
 */
export function resolveStoredPaletteSelection(value, supportedIds, defaultId, legacyAliases = {}) {
  const supported = new Set(supportedIds);
  const raw = typeof value === "string" ? value.trim() : "";
  const safeRaw = /^[a-z0-9][a-z0-9_-]{0,79}$/i.test(raw) ? raw : "";
  const legacy = safeRaw ? legacyAliases[safeRaw] : undefined;
  const candidate = legacy || safeRaw;

  if (supported.has(candidate)) {
    return {
      storedId: candidate,
      renderId: candidate,
      supported: true,
    };
  }

  return {
    storedId: safeRaw || defaultId,
    renderId: defaultId,
    supported: !safeRaw,
  };
}

export function normalizeSyncedThemeUnlockIds(value, limit = 32) {
  if (!Array.isArray(value)) return null;
  const normalized = [];
  const seen = new Set();
  for (const candidate of value) {
    if (typeof candidate !== "string") continue;
    const id = candidate.trim();
    if (!/^[a-z0-9][a-z0-9_-]{0,79}$/i.test(id) || seen.has(id)) continue;
    seen.add(id);
    normalized.push(id);
    if (normalized.length >= limit) break;
  }
  return normalized;
}
